import { render, staticRenderFns } from "./CompleteTask.vue?vue&type=template&id=046d2dec&scoped=true&"
import script from "./CompleteTask.vue?vue&type=script&lang=js&"
export * from "./CompleteTask.vue?vue&type=script&lang=js&"
import style0 from "./CompleteTask.vue?vue&type=style&index=0&id=046d2dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d2dec",
  null
  
)

export default component.exports